import React from 'react';
import Login from './components/login/Login';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";
import Register from './components/register/register';

function App() {
  return (
    <Router>
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />
        </Routes>
    </Router>
  );
}

export default App;